<template>
    <div>
        <b-container>
            <b-card class="bg-template shadow mt-4 h-100">
                <b-row>
                    <b-col align-self="center" cols="auto">
                        <figure class="avatar avatar-60">
                            <img :src="user.photo ? '/'+user.photo : '/img/user-default.png'"
                                 :alt="(user.name + ' ' + user.lname).replace(',', '')"
                                 :title="(user.name + ' ' + user.lname).replace(',', '')">
                        </figure>
                    </b-col>
                    <b-col align-self="center" class="pl-0">
                        <h5 class="mb-1">{{ (user.name + ' ' + user.lname).replace(',', '') }}</h5>
                        <p class="text-mute small">
                            <strong>ID: {{ user.id === null ? '' : (user.id).toString().padStart(5, 0) }}</strong>
                        </p>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>
        <b-container>
            <b-row>
                <b-col cols="12" class="px-0">
                    <b-list-group flush class="my-4">
                        <template v-for="item in items">
                            <b-list-group-item :to="'/partner/account/' + item.link">
                                <h6 class="text-dark mb-0 font-weight-normal">
                                    <i class="material-icons align-middle">{{ item.icon }}</i>
                                    <span class="align-middle"> {{ item.name }} </span>
                                    <i class="material-icons float-right">chevron_right</i>
                                </h6>
                            </b-list-group-item>
                        </template>
                        <b-list-group-item button @click="logout">
                            <h6 class="text-danger mb-0 font-weight-normal">
                                <i class="material-icons align-middle">power_settings_new</i>
                                <span class="align-middle"> Cerrar Sesión </span>
                                <i class="material-icons float-right">chevron_right</i>
                            </h6>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    name: "PartnerProfile",
    props: [ 'user' ],
    data: () => ({
        items: [
            { name: "Mis Datos", icon: "badge", link: "information" },
            { name: "Mis Clientes", icon: "people", link: "customers" },
            { name: "Historial", icon: "history", link: "history" },
            { name: "Seguridad", icon: "lock", link: "security" },
            { name: "Soporte", icon: "support_agent", link: "support" },
            { name: "Ayuda", icon: "help", link: "help" }
        ]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'profilepage');
    },
    methods: {
        async logout() {
            await this.$store.dispatch("logout");
            this.$root.$bvToast.toast('Has cerrado sesion correctamente.', {
                title: 'Felicitaciones',
                headerClass: 'd-none',
                variant: 'info',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
            await this.$router.push({name: "Login"});
        }
    }
}
</script>

<style scoped>

</style>
